/* eslint-disable */
const iconCartPositionStyle = ( { nodeElement, iconCart } ) => {
	// get x & y position of iconCart
	const rect = iconCart.getBoundingClientRect();
	nodeElement.style.top = `${rect.top}px`;
	nodeElement.style.left = `${rect.left}px`;
	nodeElement.style.position = 'fixed';
	nodeElement.style.zIndex = '30';
	nodeElement.style.width = `${iconCart.offsetWidth}px`;
	nodeElement.style.height = `${iconCart.offsetHeight}px`;
	nodeElement.style.padding = '0.5rem';
};

export const iconCartPosition = () => {
	const c7Cart = document.getElementById( 'c7-cart' );
	if ( c7Cart ) {
		// observer if has nodeChild
		const iconCart = document.getElementById( 'iconCart' );
		const observer = new MutationObserver( ( mutations ) => {
			mutations.forEach( ( mutation ) => {
				if ( mutation.addedNodes.length ) {
					const button =
						mutation.addedNodes[0].querySelector( 'button' );
					if ( button ) {
						iconCartPositionStyle( { nodeElement: button, iconCart } );
						button
							.querySelector( '.c7-user-nav__cart__title' )
							.remove();
						iconCart.appendChild(
							button.querySelector( '.c7-user-nav__cart__count' )
						);

						window.addEventListener( 'resize', () => {
							iconCartPositionStyle( { nodeElement: button, iconCart } );
						} );
					}

					// stop observer
					observer.disconnect();
				}
			} );
		} );
		observer.observe( c7Cart, { childList: true } );
	}
};
